module.exports = __webpack_public_path__ + "img/edit.8e64c562.svg";